<!-- <router-outlet></router-outlet> -->
<div class="ambient">
  <div class="grid-bg"></div>
  <div class="mesh a"></div>
  <div class="mesh b"></div>
  <div class="mesh c"></div>
</div>
<div class="grain"></div>

<app-header />
<app-hero />
<app-how-it-works />
<app-benefits />
<app-industry />
<app-assistant />
<app-app-cta />
<app-footer />